!(function () {
  "use strict";
  function t(t, e) {
    e = e || {};
    var i = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = i),
      t.focus(),
    void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function n(o) {
        o.target.removeEventListener(o.type, n), (t.tabIndex = i), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function e(t) {
    return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function (t) {
      return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || ((e = t), (i = window.getComputedStyle(e)), "none" === i.display || "hidden" === i.visibility));
      var e, i;
    });
  }
  var i = {};
  function n() {
    document.removeEventListener("focusin", i.focusin), document.removeEventListener("focusout", i.focusout), document.removeEventListener("keydown", i.keydown);
  }
  var o = Object.freeze({
    __proto__: null,
    forceFocus: t,
    focusHash: function (e) {
      e = e || {};
      var i = window.location.hash,
        n = document.getElementById(i.slice(1));
      if (n && e.ignore && n.matches(e.ignore)) return !1;
      i && n && t(n, e);
    },
    bindInPageLinks: function (e) {
      return (
        (e = e || {}),
          Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (i) {
            if ("#" === i.hash || "" === i.hash) return !1;
            if (e.ignore && i.matches(e.ignore)) return !1;
            if (((n = i.hash.substr(1)), null === document.getElementById(n))) return !1;
            var n,
              o = document.querySelector(i.hash);
            return (
              !!o &&
              (i.addEventListener("click", function () {
                t(o, e);
              }),
                !0)
            );
          })
      );
    },
    focusable: e,
    trapFocus: function (o, r) {
      r = r || {};
      var s = e(o),
        a = r.elementToFocus || o,
        c = s[0],
        l = s[s.length - 1];
      n(),
        (i.focusin = function (t) {
          o !== t.target && !o.contains(t.target) && c && c === t.target && c.focus(), (t.target !== o && t.target !== l && t.target !== c) || document.addEventListener("keydown", i.keydown);
        }),
        (i.focusout = function () {
          document.removeEventListener("keydown", i.keydown);
        }),
        (i.keydown = function (t) {
          "Tab" === t.code && (t.target !== l || t.shiftKey || (t.preventDefault(), c.focus()), (t.target !== o && t.target !== c) || !t.shiftKey || (t.preventDefault(), l.focus()));
        }),
        document.addEventListener("focusout", i.focusout),
        document.addEventListener("focusin", i.focusin),
        t(a, r);
    },
    removeTrapFocus: n,
    autoFocusLastElement: function () {
      window.accessibility.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        window.accessibility.lastElement?.focus();
      });
    },
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var i = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
          },
          n = e.prefix || "a11y",
          o = { newWindow: n + "-new-window-message", external: n + "-external-message", newWindowExternal: n + "-new-window-external-message" };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            i = t.getAttribute("rel"),
            n = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            r = "_blank" === e,
            s = null === i || -1 === i.indexOf("noopener");
          if (r && s) {
            var a = null === i ? "noopener" : i + " noopener";
            t.setAttribute("rel", a);
          }
          n && r ? t.setAttribute("aria-describedby", o.newWindowExternal) : n ? t.setAttribute("aria-describedby", o.external) : r && t.setAttribute("aria-describedby", o.newWindow);
        }),
          (function (t) {
            var e = document.createElement("ul"),
              i = Object.keys(t).reduce(function (e, i) {
                return e + "<li id=" + o[i] + ">" + t[i] + "</li>";
              }, "");
            e.setAttribute("hidden", !0), (e.innerHTML = i), document.body.appendChild(e);
          })(i);
      }
    },
  });
  function r() {
    return (document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth) < window.theme.sizes.small;
  }
  function s() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
        (t.footerHeight = a('[data-section-type*="footer"]')),
        (t.headerHeight = a("[data-header-height]")),
        (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0),
        (t.collectionNavHeight = a("[data-collection-nav]")),
        (t.logoHeight = (function () {
          const t = a("[data-footer-logo]");
          return t > 0 ? t + 20 : 0;
        })()),
        t
    );
  }
  function a(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  !(function () {
    if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
    if (window.matchMedia("(orientation: landscape)").matches);
  })(),
    (window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight));
  const c = "[data-section-type]",
    l = "[data-collection-sidebar]",
    d = "[data-collection-sidebar-slide-out]",
    u = "[data-collection-sidebar-close]",
    h = "[data-collection-filters-form]",
    f = "input",
    m = "select",
    p = "label",
    w = "textarea",
    v = "[data-field-price-min]",
    b = "[data-field-price-max]",
    g = "data-field-price-min",
    y = "data-field-price-max",
    E = "[data-se-min-value]",
    S = "[data-se-max-value]",
    L = "data-se-min-value",
    k = "data-se-max-value",
    q = "data-se-min",
    x = "data-se-max",
    A = "[data-show-more]",
    C = "[data-link-hidden]",
    H = "[data-collection-nav]",
    F = "[data-products-grid]",
    M = "[data-active-filters]",
    B = "data-active-filters-count",
    T = "[data-filter-update-url]",
    U = "[data-sort-enabled]",
    O = "[data-sort-link]",
    I = "data-value",
    W = "[data-popout-toggle]",
    P = "[data-sort-button-text]",
    R = "[data-results-count]",
    _ = "hidden",
    D = "is-focused",
    N = "is-loading",
    $ = "is-active";
  class j extends HTMLElement {
    constructor() {
      super(),
        (this.container = this.closest(c)),
        (this.collectionSidebar = this.container.querySelector(l)),
        (this.collectionSidebarSlideOut = this.container.querySelector(d)),
        (this.form = this.querySelector(h)),
        (this.productsContainer = this.container.querySelector(F)),
        (this.collectionNav = this.container.querySelector(H)),
        (this.sort = this.container.querySelector(U)),
        (this.sortButton = this.container.querySelector(W)),
        (this.sortLinks = this.container.querySelectorAll(O)),
        (this.filterUrlButtons = this.container.querySelectorAll(T)),
        (this.collectionSidebarCloseButtons = this.container.querySelectorAll(u)),
        (this.showMoreOptions = this.querySelectorAll(A)),
        (this.a11y = o),
        (this.updatePriceEvent = (function (t, e) {
          let i;
          return function () {
            if (t) {
              const n = () => t.apply(this, arguments);
              clearTimeout(i), (i = setTimeout(n, e));
            }
          };
        })((t) => this.updatePrice(t), 500)),
        (this.updateRangeEvent = (t) => this.updateRange(t)),
        (this.showMoreEvent = (t) => this.showMore(t)),
        (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
        (this.submitFormEvent = (t) => this.submitForm(t)),
        (this.collectionSidebarCloseEvent = (t) => this.collectionSidebarClose(t)),
        (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t));
    }
    connectedCallback() {
      this.sort &&
      this.sortLinks.length &&
      this.sortLinks.forEach((t) => {
        t.addEventListener("click", this.onSortButtonClickEvent);
      }),
      this.collectionSidebar && this.form && (this.collectionSidebar.addEventListener("input", this.updatePriceEvent), this.collectionSidebar.addEventListener("theme:range:update", this.updateRangeEvent)),
      this.showMoreOptions.length &&
      this.showMoreOptions.forEach((t) => {
        t.addEventListener("click", this.showMoreEvent);
      }),
      (this.collectionSidebar || this.sort) && window.addEventListener("popstate", this.submitFormEvent),
      this.filterUrlButtons.length &&
      this.filterUrlButtons.forEach((t) => {
        t.addEventListener("click", this.filterUpdateFromUrlEvent);
      }),
      this.collectionSidebarCloseButtons.length &&
      this.collectionSidebarCloseButtons.forEach((t) => {
        t.addEventListener("click", this.collectionSidebarCloseEvent);
      });
    }
    collectionSidebarClose(t) {
      t.preventDefault(), this.container.dispatchEvent(new CustomEvent("theme:filter:close", { bubbles: !1 }));
    }
    onSortButtonClick(t) {
      t.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(t, t.currentTarget);
    }
    sortActions(t, e, i = !0) {
      const n = this.sort.querySelector(P),
        o = this.sort.querySelector(`.${$}`);
      if (n) {
        const t = e ? e.textContent.trim() : "";
        n.textContent = t;
      }
      o && o.classList.remove($), this.sort.classList.toggle($, e), e && (e.parentElement.classList.add($), i && this.submitForm(t));
    }
    onSortCheck(t) {
      let e = null;
      if (window.location.search.includes("sort_by")) {
        const t = new window.URL(window.location.href).searchParams;
        for (const [i, n] of t.entries()) {
          const t = this.sort.querySelector(`[${I}="${n}"]`);
          if (i.includes("sort_by") && t) {
            e = t;
            break;
          }
        }
      }
      this.sortActions(t, e, !1);
    }
    showMore(t) {
      t.preventDefault();
      const e = t.target.matches(A) ? t.target : t.target.closest(A);
      e.parentElement.classList.add(_),
        e.parentElement.previousElementSibling.querySelectorAll(C).forEach((t, e) => {
          t.classList.remove(_);
          const i = t.querySelector(f);
          0 === e && document.body.classList.contains(D) && i && (this.collectionSidebarSlideOut || r() ? (this.a11y.removeTrapFocus(), this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: i })) : i.focus());
        });
    }
    updatePrice(t) {
      const e = t.type,
        i = t.target;
      if ((e === f || e === m || e === p || e === w) && this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(v),
          n = this.form.querySelector(b);
        e && n && (i.hasAttribute(g) && !n.value ? (n.value = n.placeholder) : i.hasAttribute(y) && !e.value && (e.value = e.placeholder)), this.submitForm(t);
      }
    }
    updateRange(t) {
      if (this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(E),
          i = this.form.querySelector(S),
          n = this.form.querySelector(v),
          o = this.form.querySelector(b);
        if (e && i && n && o && e.hasAttribute(L) && i.hasAttribute(k)) {
          const r = parseInt(n.placeholder),
            s = parseInt(o.placeholder),
            a = parseInt(e.getAttribute(L)),
            c = parseInt(i.getAttribute(k));
          (r === a && s === c) || ((n.value = a), (o.value = c), this.submitForm(t));
        }
      }
    }
    filterUpdateFromUrl(t) {
      t.preventDefault(), this.submitForm(t, t.currentTarget.getAttribute("href"));
    }
    submitForm(t, e = "") {
      if (!t || (t && "popstate" !== t.type))
        if ("" === e) {
          let t = new window.URL(window.location.href).searchParams;
          const e = t,
            i = Object.fromEntries(e),
            n = t.toString();
          if (n.includes("filter.") || n.includes("page=") || n.includes("sort_by=")) for (const e in i) (e.includes("filter.") || "page" === e || "sort_by" === e) && t.delete(e);
          if (this.form) {
            const e = new FormData(this.form),
              i = new URLSearchParams(e),
              n = this.form.querySelector(E),
              o = this.form.querySelector(S),
              r = n && n.hasAttribute(q) ? n.getAttribute(q) : "",
              s = o && o.hasAttribute(x) ? o.getAttribute(x) : "";
            let a = 0;
            for (let [e, n] of i.entries()) ((e.includes("filter.") && n) || (e.includes("sort_by") && n)) && (t.append(e, n), ((n === r && "filter.v.price.gte" === e) || (n === s && "filter.v.price.lte" === e)) && (a += 1));
            2 === a && (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
          }

          if (!t.has("filter.v.availability")) {
            t.append("filter.v.availability", "1");
          }

          const o = t.toString();
          const r = o ? `?${o}` : location.pathname;
          window.history.pushState(null, "", r);
        } else window.history.pushState(null, "", e);
      else this.sort && this.onSortCheck(t);
      this.productsContainer &&
      (this.productsContainer.classList.add(N),
        fetch(`${window.location.pathname}${window.location.search}`)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html"),
              i = this.container.querySelector(R);
            if (i) {
              const t = e.querySelector(R);
              i.innerHTML = t.innerHTML;
            }
            if (((this.productsContainer.innerHTML = e.querySelector(F).innerHTML), this.collectionSidebar)) {
              this.collectionSidebar.innerHTML = e.querySelector(l).innerHTML;
              const t = this.collectionSidebar.querySelector(`[${B}]`),
                i = this.container.querySelectorAll(M);
              if (t && i.length) {
                const e = parseInt(t.getAttribute(B));
                i.forEach((t) => {
                  (t.textContent = e), t.classList.toggle(_, e < 1);
                });
              }
            }
            this.collectionNav &&
            ((t) => {
              let { stickyHeaderHeight: e } = s();
              window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
            })(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight),
              setTimeout(() => {
                this.productsContainer.classList.remove(N);
              }, 500);
          })
          .catch((t) => {
            console.log(t);
          }));
    }
    disconnectedCallback() {
      this.collectionSidebar && this.form && (this.collectionSidebar.removeEventListener("input", this.updatePriceEvent), this.collectionSidebar.removeEventListener("theme:range:update", this.updateRangeEvent)),
      this.showMoreOptions.length &&
      this.showMoreOptions.forEach((t) => {
        t.removeEventListener("click", this.showMoreEvent);
      }),
      this.sort &&
      this.sortLinks.length &&
      this.sortLinks.forEach((t) => {
        t.removeEventListener("click", this.onSortButtonClickEvent);
      }),
      (this.collectionSidebar || this.sort) && window.removeEventListener("popstate", this.submitFormEvent),
      this.filterUrlButtons.length &&
      this.filterUrlButtons.forEach((t) => {
        t.removeEventListener("click", this.filterUpdateFromUrlEvent);
      }),
      this.collectionSidebarCloseButtons.length &&
      this.collectionSidebarCloseButtons.forEach((t) => {
        t.removeEventListener("click", this.collectionSidebarCloseEvent);
      });
    }
  }
  customElements.get("collection-filters-form") || customElements.define("collection-filters-form", j);
})();
//# sourceMappingURL=collection-filters-form.js.map
